export const Colors = {
  light: "#fdfeff",
  dark: "#25292d",
  purple: "#7813fe",
  lightPurple: "#E7D6FF",
  darkPurple: "#433754",

  red: "#d90429",
};
